import { FC } from 'react';

import { useNavigationHandlerPresenter } from './NavigationHandler.presenter';

export const NavigationHandler: FC = () => {
  useNavigationHandlerPresenter();

  return null;
};
